import { makeStyles } from '@material-ui/core'
import { Skeleton, useIsMobile } from '@paintscout/ui'
import React from 'react'
import times from 'lodash/times'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    gap: theme.spacing(2)
  },
  timeGutter: {
    width: '10%'
  },
  rows: {
    width: '90%'
  },
  subRows: {
    display: 'flex',
    gap: theme.spacing(1)
  },
  skeleton: {
    borderRadius: theme.borderRadius.md,
    marginBottom: theme.spacing(1)
  },
  monthRoot: {
    padding: theme.spacing(2)
  }
}))

export default function CalendarShim() {
  const classes = useStyles()
  const mobile = useIsMobile()
  return (
    <div className={classes.root}>
      <div className={classes.timeGutter}>
        <Skeleton
          className={classes.skeleton}
          variant="rect"
          width={'100%'}
          height={mobile ? '98.5%' : '99%'}
          animation="wave"
        />
      </div>
      <div className={classes.rows}>
        {times(mobile ? 6 : 9, (i) => (
          <div className={classes.subRows} key={i}>
            {times(mobile ? 3 : 5, (j) => (
              <Skeleton
                key={`${i}-${j}`}
                className={classes.skeleton}
                variant="rect"
                width={mobile ? '33%' : '20%'}
                height={70}
                animation="wave"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}

CalendarShim.title = (_: Date) => {
  return ''
}

CalendarShim.navigate = (date: Date, _: string) => {
  return date
}
